// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../../Banner';

export const BannerWithMargin = styled(Banner)`
  margin: 8px 0;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';
